import api from '../../api'
import _ from 'lodash'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  isOn: (state) => (place) => state.all.includes(place.id),
  getFavorites: (state) => state.all,
  getFavoritedPlaces: (state, _getters, _rootState, rootGetters) => {
    const places = _.cloneDeep(rootGetters['places/getPlaces'])
    const favorites = state.all
    return places.filter(place => {
      return favorites.includes(place.id)
    })
  },
  getFavoritedPlacesWithDistance: (state, _getters, _rootState, rootGetters) => (route) => {
    const from = route.points[0]
    const places = _.cloneDeep(rootGetters['places/getPlaces'])
    const favorites = state.all
    return places
      .filter(place => {
        return favorites.includes(place.id)
      }).map(place => {
        return Object.assign(place, { distance: distanceBetween(from, place) })
      }).sort((a, b) => {
        return a.distance - b.distance
      })
  },
}

const actions = {
  fetchAll ({ rootGetters, commit, dispatch }) {
    const token = rootGetters['user/getToken']

    return new Promise((resolve, reject) => {
      api.getFavorites(token)
        .then((favorites) => {
          commit('setFavorites', favorites)
          resolve()
        })
        .catch(() => {
          dispatch('user/resetToken', {}, { root: true })
          reject()
        })
    })
  },
  create ({ rootGetters, commit }, place) {
    const token = rootGetters['user/getToken']

    return new Promise((resolve, reject) => {
      api.putFavorite(place, token)
        .then(() => {
          commit('push', place)
          resolve()
        })
        .catch(() => reject())
    })
  },
  delete ({ rootGetters, commit }, place) {
    const token = rootGetters['user/getToken']

    return new Promise((resolve, reject) => {
      api.deleteFavorite(place, token)
        .then(() => {
          commit('destroy', place)
          resolve()
        })
        .catch(() => reject())
    })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setFavorites (state, favorites) {
    state.all = favorites
  },
  push (state, place) {
    state.all.push(place.id)
  },
  destroy (state, place) {
    const index = state.all.findIndex(id => id === place.id)

    if (index > -1) { state.all.splice(index, 1) }
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

/**
 * Private function
 */
// 距離を取得
function distanceBetween(from, place) {
  const d = getDistance(
    from.location.latitude,
    from.location.longitude,
    place.location.latitude,
    place.location.longitude
  )
  return Math.round(d * 100) / 100
}

function getDistance(lat1, lng1, lat2, lng2) {
  lat1 *= Math.PI / 180;
  lng1 *= Math.PI / 180;
  lat2 *= Math.PI / 180;
  lng2 *= Math.PI / 180;
  const d = 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2))

  return d;
}
